/*
 * @Author: JamesWong
 * @Description: 副屏幕中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-11-30 16:54:06
 */
export default {
  interactMode: '交互模式',
  rollingPhotos: '轮播图片',
  advertisementVideo: '广告视频',
  interactModeTips1: '1.收银机没有进行收银操作时，副屏全屏显示图片轮播/视频轮播',
  interactModeTips2: '2.收银过程中，副屏幕左侧显示图片/视频，右侧显示销售明细及交易金额',
  interactModeTips3: '3.结算完成后，副屏幕再次恢复全屏模式',
  fullscreenPhoto: '全屏图片',
  fullscreenVideo: '全屏视频',
  photoSalesDetail: '图片 + 销售明细',
  videoSalesDetail: '视频 + 销售明细',
  upload: '上传',
  preview: '预览',
  previewPhotos: '预览图片',
  delete: '删除',
  photoDeleted: '图片删除成功',
  previewVideo: '预览视频',
  videoUploaded: '上传视频成功！',
  videoSizeTips: '文件大小不能超过200M！',
  photoUploaded: '上传图片成功！',
  phoneSizeTips: '文件大小不能超过10M！',
  longNameTips: '文件名不能过长！',
  moreFileTips: '最多只能上传一个视频，请先删除原有的视频再尝试上传！',
  uploadingTips: '文件正在上传中...  请稍等',
  notSupportTips: '您的浏览器不支持 video 标签。',
  uploadProgress: '上传进度',
  noVideoTips: '你还没有上传视频，赶快上传吧',
  noPhotoTips: '你还没有上传图片，赶快上传吧',
  Unnamed: '未命名'
}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/screen.js